import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Zap, Rocket, X } from "lucide-react";

export default function BoostDialog({ postId, onClose }) {
    const { user } = useAuth();
    const [busy, setBusy] = useState(false);

    const buy = async (lookup_key) => {
        if (!user) { toast.error("Log in first"); return; }
        setBusy(true);
        try {
            const { data } = await api.post("/payments/checkout", {
                lookup_key,
                origin_url: window.location.origin,
                post_id: postId,
            });
            window.location.href = data.checkout_url;
        } catch (e) { toast.error(formatApiError(e)); setBusy(false); }
    };

    return (
        <div className="fixed inset-0 bg-[#0A0A0A]/40 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="boost-dialog-overlay">
            <div className="bg-white brut-lg rounded-xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()} data-testid="boost-dialog">
                <div className="flex items-start justify-between mb-4">
                    <div>
                        <h2 className="display text-2xl font-black">Boost this post</h2>
                        <p className="text-sm text-[#4A4A4A] font-medium">Get your best angle seen by everyone.</p>
                    </div>
                    <button onClick={onClose} className="p-1" aria-label="Close" data-testid="boost-close"><X className="w-5 h-5" /></button>
                </div>
                <div className="space-y-3">
                    <button
                        disabled={busy}
                        onClick={() => buy("post_boost")}
                        className="w-full flex items-center gap-3 p-4 rounded-xl brut bg-[#B8E1FF] text-left disabled:opacity-50"
                        data-testid="buy-post-boost"
                    >
                        <div className="w-10 h-10 rounded-lg bg-white border-2 border-[#0A0A0A] flex items-center justify-center"><Zap className="w-4 h-4" /></div>
                        <div className="flex-1">
                            <div className="font-black">Post Boost</div>
                            <div className="text-xs font-medium text-[#0A0A0A]/70">Top of Fresh · 24 hours</div>
                        </div>
                        <div className="font-black">$2.99</div>
                    </button>
                    <button
                        disabled={busy}
                        onClick={() => buy("premium_boost")}
                        className="w-full flex items-center gap-3 p-4 rounded-xl brut bg-[#FFE55C] text-left disabled:opacity-50"
                        data-testid="buy-premium-boost"
                    >
                        <div className="w-10 h-10 rounded-lg bg-white border-2 border-[#0A0A0A] flex items-center justify-center"><Rocket className="w-4 h-4" /></div>
                        <div className="flex-1">
                            <div className="font-black">Premium Boost</div>
                            <div className="text-xs font-medium text-[#0A0A0A]/70">Top of Fresh + Top rated · 48 hours + border</div>
                        </div>
                        <div className="font-black">$4.99</div>
                    </button>
                </div>
                <p className="text-[11px] text-[#4A4A4A] font-medium mt-4 text-center">
                    You can only boost your own posts. Payment processed by Stripe.
                </p>
            </div>
        </div>
    );
}
